import { ErrorHandler, Injectable } from '@angular/core';
import monitoring from 'src/utils/monitoring';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    monitoring.catchError(error);
  }
}
